import { View, Text, Dimensions, Animated, ImageBackground, ScrollView, StyleSheet } from 'react-native'
import React, { useEffect, useState } from 'react'
import { BlurView } from 'expo-blur'
import FeedIcons from '../../assets/Icons/FeedIcons'
import { Colors } from '../../globalStyles/ColorConfig'
import CustomComponent from '../../components/CustomComponent'
import { useNavigation } from '@react-navigation/native'
import ChatCoachMarkScreen from './CoachMarkScreen/ChatCoachMarkScreen'
import AsyncStorage from '@react-native-async-storage/async-storage'
import GlobalStyles from '../../globalStyles/globalStyles'
import InterestScreenIcons from '../../assets/Icons/InterestIcons'
import ChatIcons from '../../assets/Icons/ChatIcons'

export default function Matches() {
  const navigation = useNavigation();

  const [showCoachMark, setShowCoachMark] = useState(false);
  const [coachMarkVisited, setCoachMarkVisited] = useState(false);
  const [opacity] = useState(new Animated.Value(0));

  useEffect(() => {
    const checkCoachMarkVisited = async () => {
      try {
        const visited = await AsyncStorage.getItem('chatCoachMarkVisited');
        if (visited !== null) {
          setCoachMarkVisited(true);
        }
      } catch (error) {
        console.error('Error retrieving coach mark visit status:', error);
      }
    };

    checkCoachMarkVisited();
  }, []);

  //responsible for the transition between the 2 screens
  useEffect(() => {
      let timer:any;
      if (!coachMarkVisited) {
        timer = setTimeout(() => {
        Animated.timing(opacity, {
          toValue: 1,
          duration: 1000,
          useNativeDriver: true,
        }).start();
          setShowCoachMark(true);
        }, 1000);
      }
      return () => clearTimeout(timer);
  }, [coachMarkVisited]);

  const handleGotIt = async () => {
    try {
      await AsyncStorage.setItem('chatCoachMarkVisited', 'true');
      setCoachMarkVisited(true);
      Animated.timing(opacity, {
        toValue: 0,
        duration: 1000,
        useNativeDriver: true,
      }).start(() => setShowCoachMark(false));
    } catch (error) {
      console.error('Error setting coach mark visit status:', error);
    }
  };


  return (
    <View style={{
      position:"relative",
      flex:1
    }}>
      {
      showCoachMark &&
        <Animated.View style={{ 
          flex: 1, 
          opacity:opacity,
          position:"absolute",
          width:"100%",
          height:"100%",
          zIndex:showCoachMark? 2:0
          }}>
          <ChatCoachMarkScreen onGotIt={handleGotIt} />
        </Animated.View>
     }
     <View style={{
      position:"absolute",
      flex:1,
      width:"100%",
      height:"100%"
     }}>
     <ImageBackground
      source={require("../../assets/StaticImages/ChatImages/chatscreen_date1.png")}
        style={{
          flex: 1,
          backgroundColor: "#000",
          // marginTop: 15,
        }}
      >
        <ScrollView>
          <View style={styles.Container}>
            <Text
              style={[
                GlobalStyles.heading2,
                {
                  paddingHorizontal: 16,
                  color:"white"
                },
              ]}
            >
              Chat
            </Text>
           
           <View
                  style={{
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "57%",
                  }}
                >
                  <View
                    style={{
                      transform: [{ scale: 1.9 }],
                    }}
                  >
                    <ChatIcons.MainChatScreenIcon />
                  </View>
                  <Text
                    style={[
                      GlobalStyles.heading2,
                      { marginTop: 40, textAlign: "center",color:"white" },
                    ]}
                  >
                    Spark {"\n"}
                    enchanting {"\n"}
                    conversations
                  </Text>
                </View>
            
          </View>
        </ScrollView>
      </ImageBackground>
     </View> 
    </View>
  )
}

const styles = StyleSheet.create({
  Container:{
   marginTop: 20,
  }
})

{/* <View>
       <BlurView
        tint="dark"
        intensity={60}
        style={{
          position: "absolute",
          flex: 1,
          zIndex: 40,
          width: Dimensions.get("window").width,
          height: Dimensions.get("window").height,
          backgroundColor: "rgba(0,0,0,0.8)",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <FeedIcons.ComingSoon />
        <View
          style={{
            width: "80%",
          }}
        >
          <CustomComponent.AppBtn
            name="Explore Experiences"
            onPress={() => {
              navigation.navigate("Discover" as never);
            }}
            style={{
              marginTop: 20,
              backgroundColor: "transparent",
              paddingVertical: 15,
              borderColor: "white",
              borderWidth: 0.5,
              borderRadius: 40,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
            textStyle={{
              color: "white",
            }}
          />
        </View>
      </BlurView>
      <Text>Matches</Text>
</View> */}